import React, { useEffect, useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function VerRoles({ data, onClose = () => {} }) {
  // Estado para la lista de permisos
  const [permisos, setPermisos] = useState([]);
  const [loadingPermisos, setLoadingPermisos] = useState(false);

  // Definir el orden de prioridad para las acciones
  const accionPrioridad = {
    LIST: 1,
    VIEW: 2,
    INSERT: 3,
    UPDATE: 4,
    DELETE: 5,
  };

  // Efecto para cargar los permisos al abrir el modal
  useEffect(() => {
    if (!data?.id) return;

    setLoadingPermisos(true);
    // Llamamos al endpoint que filtra por rolId
    appFetchJson(apiRoutes.roles.permisos.list(data.id))
      .then((resp) => {
        // Asumiendo que el backend devuelve un objeto paginado { items: [...] } o lista directa
        let lista = resp.items || resp.content || resp || [];
        
        // Ordenar la lista:
        lista.sort((a, b) => {
          const modA = a.subModuloNombre || '';
          const modB = b.subModuloNombre || '';
          
          // Comparación primaria: subModuloNombre
          const compareMod = modA.localeCompare(modB);
          if (compareMod !== 0) return compareMod;

          // Comparación secundaria: accion (usando el orden de prioridad)
          const prioridadA = accionPrioridad[a.accion] || 999; // 999 para acciones no definidas
          const prioridadB = accionPrioridad[b.accion] || 999;
          return prioridadA - prioridadB;
        });

        setPermisos(lista);
      })
      .catch((err) => console.error("Error cargando permisos:", err))
      .finally(() => setLoadingPermisos(false));
  }, [data]);

  if (!data) return null;

  return (
    <>
      {/* Encabezado */}
      <div className="modal-header">
        <h2 className="section-title">Permisos para el Rol: {data.rol}</h2>
      </div>

      {/* Contenido (Scrolleable verticalmente) */}
      <div className="modal-body overflow-y-auto max-h-[70vh] p-4">
        
        {/* --- Sección: Tabla de Permisos --- */}
        <h3 className="text-md font-bold text-gray-700 mb-3 pl-1 border-l-4 border-green-600">
          Permisos Asignados
        </h3>

        {loadingPermisos ? (
          <div className="text-center py-4 text-gray-500">Cargando permisos...</div>
        ) : (
          <div className="overflow-x-auto border rounded-lg shadow-sm">
            <table className="table-card table-xs w-full">
              <thead className="bg-green-600 text-white">
                <tr>
                  <th className="px-2 py-2 text-left whitespace-nowrap">Módulo</th>
                  <th className="px-2 py-2 text-left whitespace-nowrap">Permiso</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {permisos.length === 0 ? (
                  <tr>
                    <td colSpan={2} className="text-center py-4 text-gray-500 italic">
                      No se encontraron permisos para este rol.
                    </td>
                  </tr>
                ) : (
                  permisos.map((permiso, idx) => (
                    <tr key={permiso.id || idx} className="hover:bg-gray-50">
                      <td className="px-2 py-1 whitespace-nowrap">{permiso.subModuloNombre || "-"}</td>
                      <td className="px-2 py-1 whitespace-nowrap">{permiso.accion || "-"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
        
        {!loadingPermisos && permisos.length > 0 && (
          <div className="text-center text-xs text-gray-500 mt-2">
            {permisos.length} permiso{permisos.length !== 1 ? "s" : ""} encontrado{permisos.length !== 1 ? "s" : ""}.
          </div>
        )}

      </div>

      {/* Footer */}
      <div className="modal-footer">
        <div className="flex justify-end">
          <button onClick={onClose} className="btn-fil">
            Cerrar
          </button>
        </div>
      </div>
    </>
  );
}
